import React, { FC, Fragment, useState } from 'react';
import { Filter } from 'components/molecules/filters/types';
import { DateRange } from 'components/organisms/projects-report/common/range-picker/types';
import { unreachable } from 'utils/unreachable';
import { AllTask } from '../all-task';
import { OuterWrapper, SubtabWrapper } from '../components';
import { TemplateInsightSubTask, TemplateInsightViews } from '../constant';
import { TemplateInsightSubTabSwitcher } from '../template-insight-sub-tab-switcher';
import { ByPhases } from './by-phases';
import { ByProject } from './by-project';

interface Props {
  range: DateRange;
  filter: Filter;
}

const SelectedView = TemplateInsightViews.ByTemplate;
const [project, phases, tasks] = TemplateInsightSubTask[SelectedView];

const SubTabComponent = {
  loading: Fragment,
  [project]: ByProject,
  [phases]: ByPhases,
  [tasks]: AllTask,
};

export const TemplateInsightByTemplateId: FC<Props> = ({ range, filter }) => {
  const [subTab, setSubTab] = useState('loading');
  const Component = SubTabComponent[subTab] || unreachable(subTab as never);

  return (
    <OuterWrapper>
      <SubtabWrapper>
        <TemplateInsightSubTabSwitcher
          view={SelectedView}
          onSwitch={setSubTab}
        />
      </SubtabWrapper>
      <Component range={range} filter={filter} />
    </OuterWrapper>
  );
};
